<div class="timesheets-page">
    <div class="no-print">
        <ppw-toolbar [menuTitle]="pageTitle" showMenu="true" singleButton="!viewingMode">
            <div class="ppw-speed-dial-position">
                <div fxLayout="row">
                    <ppw-multi-client-warning
                        [isShown]="hasMultiClientsInMultiSelect"
                        message="Multiple clients selected !"></ppw-multi-client-warning>
                    <div *ngIf="viewTimesheet">
                        <div
                            [matTooltip]="
                                hasUnapprovedInSelection ? 'Set to \'Approved\'' : 'Already set to \'Approved\''
                            "
                            class="button-wrapper">
                            <button
                                mat-mini-fab
                                class="speed-dial-button"
                                color="accent"
                                [disabled]="!hasUnapprovedInSelection || !isAuthForAllButRestricted"
                                (click)="approveSelectedTimesheets()">
                                <mat-icon>assignment_turned_in</mat-icon>
                            </button>
                        </div>
                        <div
                            [matTooltip]="
                                hasUnapprovedInSelection
                                    ? 'Only approved timesheets can be set to \'Do Not Invoice\''
                                    : !hasUninvoicedInSelection
                                    ? 'Some timesheets have already been invoiced'
                                    : hasToBeInvoicedInSelection
                                    ? 'Set to \'Do Not Invoice\''
                                    : 'Already set to \'Do Not Invoice\''
                            "
                            class="button-wrapper">
                            <button
                                mat-mini-fab
                                class="speed-dial-button"
                                color="accent"
                                [disabled]="
                                    hasUnapprovedInSelection ||
                                    !hasUninvoicedInSelection ||
                                    !hasToBeInvoicedInSelection ||
                                    isViewByTag ||
                                    !isAuthForAllButRestricted
                                "
                                (click)="doNotInvoiceSelectedTimesheets()">
                                <mat-icon>not_interested</mat-icon>
                            </button>
                        </div>
                        <div
                            [matTooltip]="
                                hasUnapprovedInSelection
                                    ? 'Only approved timesheets can be invoiced'
                                    : hasDoNotInvoiceInSelection
                                    ? 'Some timesheets are set to \'do not invoice\''
                                    : hasUninvoicedInSelection
                                    ? 'Set to \'Invoiced\''
                                    : 'Already set to \'Invoiced\''
                            "
                            class="button-wrapper">
                            <button
                                mat-mini-fab
                                class="speed-dial-button"
                                color="accent"
                                [disabled]="
                                    hasUnapprovedInSelection ||
                                    hasDoNotInvoiceInSelection ||
                                    !hasUninvoicedInSelection ||
                                    isViewByTag ||
                                    !isAuthForAllButRestricted
                                "
                                (click)="invoiceSelectedTimesheets()">
                                <mat-icon>euro_symbol</mat-icon>
                            </button>
                        </div>
                        <div
                            class="button-wrapper"
                            [matTooltip]="
                                selectedTimesheets.length === 1 && selectedTimesheets[0].state !== 0
                                    ? 'RESET statuses \'Approved\', \'Do Not Invoice\' and \'Invoiced\''
                                    : 'No timesheet statuses to be reset'
                            ">
                            <button
                                mat-mini-fab
                                class="speed-dial-button"
                                color="warn"
                                [disabled]="
                                    selectedTimesheets.length !== 1 ||
                                    selectedTimesheets[0].state === 0 ||
                                    !isAuthForAllButRestricted
                                "
                                (click)="resetTimesheet()">
                                <mat-icon>undo</mat-icon>
                            </button>
                        </div>
                        <button
                            mat-mini-fab
                            class="speed-dial-button"
                            matTooltip="Print timesheets"
                            [disabled]="selectedTimesheets.length < 1"
                            (click)="printTimesheets()">
                            <mat-icon>print</mat-icon>
                        </button>
                        <button
                            mat-mini-fab
                            class="speed-dial-button"
                            [disabled]="selectedTimesheets.length === 0"
                            matTooltip="Calculate totals for selected timesheets"
                            (click)="calculateTotals()">
                            <mat-icon>playlist_add</mat-icon>
                        </button>
                        <button mat-icon-button matTooltip="Close Timesheet(s)" (click)="toggleTimesheet()">
                            <mat-icon>visibility_off</mat-icon>
                        </button>
                    </div>
                    <div
                        class="button-wrapper"
                        *ngIf="!viewTimesheet"
                        [matTooltip]="selectedTimesheets.length === 0 ? 'No timesheet(s) selected' : 'View Timesheet'">
                        <button
                            mat-icon-button
                            [disabled]="selectedTimesheets.length === 0"
                            (click)="toggleTimesheet()">
                            <mat-icon>visibility</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </ppw-toolbar>
        <ppw-app-date-selector
            *ngIf="!viewTimesheet"
            [config]="dateSelectorConfig"
            (emitCriteria)="fetchTimesheetWithDates($event)"></ppw-app-date-selector>
    </div>
    <div class="table-container">
        <ppw-timesheets-table
            *ngIf="latestDatasource"
            [isViewByTag]="isViewByTag"
            [datasourceSubject]="datasourceSubject"
            [latestDatasource]="latestDatasource"
            (timesheetClickedEmitter)="setSelectedTimesheets($event)"
            (latestDatasourceChangedEmitter)="setLatestDatasource($event)"
            (timesheetDbClickedEmitter)="toggleTimesheet()"
            [viewTimesheet]="viewTimesheet"
            [scrollToSelectedTimesheet$]="scrollToSelectedTimesheet$"
            [datasource$]="datasource$"></ppw-timesheets-table>

        <ng-container *ngIf="viewTimesheet">
            <ppw-timesheets-detail
                *ngFor="let timesheet of selectedTimesheets; trackBy: trackBy; let first = first"
                [class.page-break-on-print]="!first"
                [isViewByTag]="isViewByTag"
                [timesheet]="timesheet"></ppw-timesheets-detail>
        </ng-container>
    </div>
</div>
